/** TODO: Delete when migrating apply */
import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';

import RoutingNumberInput from './RoutingNumberInput';

const InputBankRoutingNumber = ({ name = 'routingNumber' }) => (
  <ValidatedTextField
    name={name}
    control={useFormContext().control}
    rules={{
      required: 'This field is required.',
      // Pattern matching handles format so we only need to check length.
      validate: (v) => v.trim().length === 9 || 'Please enter a 9-digit Routing Number.',
    }}
  >
    <TextField
      fullWidth
      label="Routing Number"
      InputProps={{ inputComponent: RoutingNumberInput }}
    />
  </ValidatedTextField>
);

export default InputBankRoutingNumber;
